import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Icon from "@/components/icon/Icon";
import { Close, Search, Sizes } from "@/components/icon/IconList";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { TextField } from "@bookips/solvook-ui-library";
import { Box, Divider, IconButton, InputBase, MenuItem, Paper, styled } from "@mui/material";
import { useState } from "react";
import { SubjectsWithString } from "src/api/product";
import { useBrandStore } from "../BrandProvider";
import useSearchBarHandler from "./Search/useSearchBarHandler";
const DefaultInput = (props)=>{
    return /*#__PURE__*/ _jsx(InputBase, {
        ...props
    });
};
const BrandSearchBar = (param)=>{
    let { keyword , handleKeyword , currentSubject , handleMenu , handleMenuChange , submit  } = param;
    const [focus, setFocus] = useState(false);
    const name = useBrandStore((state)=>state.brand.name);
    const { deleteKeyword , handleChangePath  } = useSearchBarHandler({
        useAsPath: true
    });
    return /*#__PURE__*/ _jsxs(SearchBarBox, {
        className: keyword || focus ? "active" : "",
        component: "form",
        onSubmit: (e)=>{
            e.preventDefault();
        },
        children: [
            /*#__PURE__*/ _jsxs(HandlerBox, {
                select: true,
                value: currentSubject || "",
                onChange: (e)=>{
                    //mx-191
                    mixpanelEvent("Search Type Handler Clicked", {
                        Type: "Brand Home",
                        "Brand Name": name
                    });
                    handleMenuChange(e.target.value);
                },
                onFocus: ()=>setFocus(true),
                onBlur: ()=>setFocus(false),
                children: [
                    handleMenu.length > 1 && /*#__PURE__*/ _jsx(MenuItem, {
                        value: "all",
                        children: "전체"
                    }, 0),
                    handleMenu.map((menu, index)=>/*#__PURE__*/ _jsx(MenuItem, {
                            value: menu,
                            children: "".concat(SubjectsWithString[menu], " 자료")
                        }, index + 1))
                ]
            }),
            /*#__PURE__*/ _jsxs(InputBox, {
                className: keyword || focus ? "active" : "",
                children: [
                    /*#__PURE__*/ _jsx(DefaultInput, {
                        value: keyword,
                        onFocus: ()=>setFocus(true),
                        onBlur: ()=>setFocus(false),
                        onChange: (e)=>{
                            handleKeyword(e.target.value);
                        },
                        placeholder: "이 브랜드의 상품 찾기"
                    }),
                    (keyword === null || keyword === void 0 ? void 0 : keyword.length) > 0 && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(IconButton, {
                                type: "button",
                                onClick: ()=>{
                                    handleKeyword("");
                                    deleteKeyword();
                                    handleChangePath();
                                },
                                color: "primary",
                                sx: (theme)=>{
                                    return {
                                        p: "8px",
                                        i: {
                                            backgroundColor: theme.palette.grey[800],
                                            borderRadius: "50%",
                                            padding: "2px"
                                        }
                                    };
                                },
                                children: /*#__PURE__*/ _jsx(Icon, {
                                    icon: Close,
                                    size: Sizes.small,
                                    color: "#fff"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Divider, {
                                sx: {
                                    height: 12,
                                    m: 1
                                },
                                orientation: "vertical"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(IconButton, {
                        type: "submit",
                        onClick: submit,
                        sx: {
                            p: "8px",
                            ":hover": {
                                backgroundColor: "transparent"
                            }
                        },
                        children: /*#__PURE__*/ _jsx(Icon, {
                            icon: Search,
                            size: Sizes.medium
                        })
                    })
                ]
            })
        ]
    });
};
const SearchBarBox = styled(Paper)((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        height: "48px",
        alignItems: "center",
        // margin: '32px 0',
        overflow: "hidden",
        borderRadius: "24px",
        backgroundColor: "rgba(169, 175, 199, 0.2)",
        // margin: '40px 0 ',
        "& .MuiTextField-root": {
            height: "100%"
        },
        "&.active": {
            border: "1px solid ".concat(theme.palette.grey[200])
        },
        [theme.breakpoints.down("lg")]: {
            margin: "0 32px"
        },
        [theme.breakpoints.down("sm")]: {
            margin: "0 20px"
        }
    };
});
// mui paper 이슈로 인해, 타입을 한번 더 paper로 잡아주었습니다. https://github.com/mui/material-ui/issues/13921
const InputBox = styled(Box)((param)=>{
    let { theme  } = param;
    return {
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "space-between",
        padding: "6px 12px",
        "&.active": {
            backgroundColor: theme.palette.blackAndWhite.white
        },
        ".MuiInputBase-root": {
            width: "100%",
            input: {}
        },
        ":hover": {
            backgroundColor: "rgba(169, 175, 199, 0.20)"
        }
    };
});
const HandlerBox = styled(TextField)((param)=>{
    let { theme  } = param;
    return {
        flexShrink: 0,
        "& .MuiInputBase-input": {
            ...theme.typography.subtitle2
        },
        "& .MuiOutlinedInput-root": {
            backgroundColor: "transparent !important",
            borderRadius: "0",
            height: "100%",
            "&:hover": {
                backgroundColor: "rgba(169, 175, 199, 0.2) !important"
            }
        },
        "& fieldset": {
            borderColor: "transparent !important"
        }
    };
});
export default BrandSearchBar;
